// ============================================
// Reklam Verme Google - Blog Content
// ============================================

import { BlogContent } from '../../types';

export const reklamVermeGoogleContent: BlogContent = {
  tableOfContents: [
    { id: "baslangic", title: "Google'da Reklam Başlangıcı" },
    { id: "kampanya-tipleri", title: "Kampanya Tipleri" },
    { id: "butce", title: "Bütçe Stratejileri" },
    { id: "optimizasyon", title: "Optimizasyon" }
  ],
  content: [
    {
      type: "paragraph",
      value: "<strong>Google'da reklam verme</strong> süreçleri ve stratejileri. Başlangıçtan uzmanlığa tam rehber."
    }
  ]
};

export default reklamVermeGoogleContent;
